"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AdvancedFilterEditor;
var _Add = _interopRequireDefault(require("@mui/icons-material/Add"));
var _Adjust = _interopRequireDefault(require("@mui/icons-material/Adjust"));
var _DeleteOutline = _interopRequireDefault(require("@mui/icons-material/DeleteOutline"));
var _LibraryAddOutlined = _interopRequireDefault(require("@mui/icons-material/LibraryAddOutlined"));
var _MoreVert = _interopRequireDefault(require("@mui/icons-material/MoreVert"));
var _ContentPaste = _interopRequireDefault(require("@mui/icons-material/ContentPaste"));
var _Autocomplete = _interopRequireDefault(require("@mui/material/Autocomplete/Autocomplete.js"));
var _Box = _interopRequireDefault(require("@mui/material/Box/Box.js"));
var _Button = _interopRequireDefault(require("@mui/material/Button/Button.js"));
var _Chip = _interopRequireDefault(require("@mui/material/Chip/Chip.js"));
var _Dialog = _interopRequireDefault(require("@mui/material/Dialog/Dialog.js"));
var _DialogActions = _interopRequireDefault(require("@mui/material/DialogActions/DialogActions.js"));
var _DialogTitle = _interopRequireDefault(require("@mui/material/DialogTitle/DialogTitle.js"));
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl/FormControl.js"));
var _InputLabel = _interopRequireDefault(require("@mui/material/InputLabel/InputLabel.js"));
var _List = _interopRequireDefault(require("@mui/material/List/List.js"));
var _ListItemButton = _interopRequireDefault(require("@mui/material/ListItemButton/ListItemButton.js"));
var _ListItemIcon = _interopRequireDefault(require("@mui/material/ListItemIcon/ListItemIcon.js"));
var _ListItemText = _interopRequireDefault(require("@mui/material/ListItemText/ListItemText.js"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem/MenuItem.js"));
var _Select = _interopRequireDefault(require("@mui/material/Select/Select.js"));
var _TextField = _interopRequireDefault(require("@mui/material/TextField/TextField.js"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography/Typography.js"));
var _lodash = require("lodash");
var _react = require("react");
var _Help = _interopRequireDefault(require("../icons/Help"));
var _filterUtils = require("../utils/filterUtils");
var _AsyncResourceValueSelect = _interopRequireDefault(require("./AsyncResourceValueSelect"));
var _ComparisonSelector = _interopRequireWildcard(require("./ComparisonSelector"));
var _MenuIcon = _interopRequireDefault(require("./MenuIcon"));
var _styles = require("@mui/styles");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** indexes to the nested location of specified filter */

const useStyles = (0, _styles.makeStyles)(theme => ({
  icon: {
    color: theme.palette.text.primary
  }
}));

/** Build a nested filter using either a string or Filter object */
function AdvancedFilterEditor({
  value,
  onCancel,
  onChange,
  ...rest
}) {
  const [draft, setDraft] = (0, _react.useState)(null);
  const [parseError, setParseError] = (0, _react.useState)(false);
  const dirty = !(0, _lodash.isEqual)(removeKeys(draft), value);
  (0, _react.useEffect)(() => {
    let filters;
    setParseError(false);
    if (typeof value === 'string') {
      if (!rest.properties?.length) return;
      try {
        filters = (0, _filterUtils.stringToFilters)(rest.properties, value);
      } catch (e) {
        setParseError(true);
      }
    } else {
      filters = value;
    }
    const filtersWithKeys = addKeys(filters);
    if (dirty) setDraft(filtersWithKeys);
  }, [value, rest.properties]);
  function handleChange(filters) {
    setDraft(filters.type === 'filter' ? undefined : filters);
    if (parseError) setParseError(false);
  }
  function handleApply() {
    const filters = removeKeys(draft);
    //@ts-ignore
    onChange(typeof value === 'string' ? (0, _filterUtils.filtersToString)(filters) : filters);
  }
  function handleSimplify() {
    setDraft((0, _filterUtils.simplifyFilters)(draft, true));
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    children: [parseError && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
        variant: "h5",
        color: "error",
        gutterBottom: true,
        children: "Parsing error"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
        children: "The filter string was not able to be parsed. Feel free to create a new filter expression :/"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      flex: 1,
      overflow: "auto",
      ml: 1,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(FilterGroup, {
        allFilters: draft,
        disableBorder: true,
        onChange: handleChange,
        onGroupToggle: pointer => setDraft(toggleGroupAtPointer(draft, pointer)),
        pointer: [],
        value: draft,
        ...rest
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      display: "flex",
      justifyContent: "flex-end",
      gap: 1,
      m: 1,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(HelpButton, {}), dirty && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        color: "error",
        onClick: onCancel,
        children: "Cancel"
      }), dirty && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        variant: "outlined",
        onClick: handleSimplify,
        children: "Simplify"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        variant: "contained",
        color: "primary",
        onClick: dirty ? handleApply : onCancel,
        children: dirty ? 'Apply' : 'Done'
      })]
    })]
  });
}
function FilterGroup({
  disableBorder,
  disableNew,
  value,
  onChange,
  pointer,
  ...rest
}) {
  function handleChange(index, filter) {
    onChange({
      ...value,
      items: value.items.map((f, i) => i === index ? filter : f)
    });
  }
  function handleDelete(index) {
    if (value.items.length === 1) onChange(value.items[0]);else onChange({
      ...value,
      items: value.items.filter((f, i) => i !== index)
    });
  }
  function handleNewFilter(index, field) {
    const property = rest.properties.find(p => p.name === field.name);
    const defaultComparison = (0, _ComparisonSelector.getComparisonOptions)(property.semanticType)[0].value;
    const filter = {
      type: 'filter',
      key: makeKey(),
      comparison: defaultComparison,
      field
    };
    if (value) {
      let items = [...value.items];
      if (items.length === index) items.push(filter);else items.splice(index, 0, filter);
      onChange({
        ...value,
        items
      });
    } else {
      onChange({
        type: 'group',
        group: 'AND',
        key: makeKey(),
        items: [filter]
      });
    }
  }
  function handleNewGroup(index) {
    const items = value.items.map((f, i) => i !== index ? f : {
      type: 'group',
      group: 'AND',
      key: makeKey(),
      items: [f]
    });
    onChange({
      ...value,
      items
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
    borderColor: "grayscale.light",
    borderRadius: "8px",
    border: disableBorder ? undefined : 2,
    mr: 0,
    p: disableBorder ? undefined : 0.5,
    width: "90%",
    children: [value?.items.map((f, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      display: "flex",
      alignItems: "flex-start",
      gap: 1,
      mt: i === 0 ? undefined : 1,
      children: [(f.type === 'filter' || i !== 0) && /*#__PURE__*/(0, _jsxRuntime.jsx)(GroupToggle, {
        value: i === 0 ? undefined : value.group,
        onToggle: () => rest.onGroupToggle([...pointer, i])
      }), f.type === 'group' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(FilterGroup, {
        disableBorder: i === 0,
        disableNew: i === 0,
        value: f,
        onChange: v => handleChange(i, v),
        pointer: [...pointer, i],
        ...rest
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(FilterItem, {
        value: f,
        onChange: v => handleChange(i, v),
        onGroup: i === 0 ? undefined : () => handleNewGroup(i),
        onDelete: () => handleDelete(i),
        onNew: f => handleNewFilter(i + 1, f),
        pointer: [...pointer, i],
        ...rest
      })]
    }, f.key)), !disableNew && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      display: "flex",
      alignItems: "center",
      gap: 1,
      mt: 1,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(GroupToggle, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(FieldSelect, {
        properties: rest.properties,
        onChange: f => handleNewFilter(value?.items?.length ?? 0, f)
      })]
    }, makeKey())]
  });
}
function FilterItem({
  appName,
  allFilters,
  getResourceValues,
  value,
  onChange,
  onDelete = null,
  onGroup = null,
  onNew = null,
  pointer,
  properties,
  resourceName,
  allowPasteCSV = false
}) {
  const {
    comparison,
    field,
    targetField,
    values
  } = value || {};
  const [menu, setMenu] = (0, _react.useState)(null);
  const [openPasteDialog, setOpenPasteDialog] = (0, _react.useState)(false);
  const [textFieldValue, setTextFieldValue] = (0, _react.useState)('');
  const [separatorOption, setSeparatorOption] = (0, _react.useState)('');
  const [inputValues, setInputValues] = (0, _react.useState)([]);
  const classes = useStyles();
  function handleField(field) {
    const property = properties.find(p => p.name === field.name);
    const defaultComparison = (0, _ComparisonSelector.getComparisonOptions)(property.semanticType)[0].value;
    onChange({
      ...value,
      comparison: defaultComparison,
      field
    });
  }
  function handleMenuField(field) {
    if (menu === 'targetField') {
      onChange({
        ...value,
        values: undefined,
        targetField: field
      });
    } else {
      onNew(field);
    }
    setMenu(null);
  }
  function handleOperatorChange(comparison) {
    onChange({
      ...value,
      comparison
    });
  }
  const handleEnterMultiple = e => {
    const inputValue = e.target.value.trim();
    if (e.key !== 'Enter' || !inputValue) return;
    if (typeof inputValue === 'string' && inputValue.includes(',')) {
      const newValues = inputValue.split(',').reduce((acc, v) => {
        const value = v.trim();
        if (value) acc.push(value);
        return acc;
      }, []);
      onChange({
        ...value,
        values: newValues
      });
    }
  };
  const handleTextFieldChange = e => {
    const value = e.target.value;
    setTextFieldValue(value);
    setSeparatorOption('');
  };
  const handleSeparatorOptionsChange = e => {
    const optionValue = e.target.value;
    setSeparatorOption(optionValue);
  };
  const handleDialogApply = async () => {
    const newValue = typeof textFieldValue === 'string' && textFieldValue?.includes(',') ? textFieldValue?.split(',') : typeof textFieldValue === 'string' && textFieldValue?.includes('|') ? textFieldValue?.split('|') : textFieldValue;
    setOpenPasteDialog(false);
    setInputValues(prevValues => {
      const updatedValues = [...prevValues, ...newValue];
      onChange({
        ...value,
        values: updatedValues
      });
      return updatedValues;
    });
  };
  const options = [',', '|'];
  (0, _react.useEffect)(() => {
    setInputValues(values ?? []);
  }, [values]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
    display: "flex",
    gap: 1,
    alignItems: "center",
    sx: {
      width: '100%'
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(FieldSelect, {
      properties: properties,
      name: field?.name,
      onChange: handleField
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ComparisonSelector.default, {
      value: comparison,
      onChange: handleOperatorChange,
      semanticType: properties.find(p => p.name === field?.name)?.semanticType,
      InputProps: {
        sx: {
          fontSize: '12px'
        }
      },
      sx: {
        minWidth: '120px',
        width: '15%'
      }
    }), targetField ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Chip.default, {
      label: properties.find(p => p.name === targetField.name).displayName,
      onDelete: () => onChange({
        ...value,
        targetField: undefined
      }),
      sx: {
        maxWidth: '60%'
      },
      variant: "outlined"
    }) : (0, _ComparisonSelector.isSelect)(comparison) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_AsyncResourceValueSelect.default, {
      appName: appName,
      filters: createSearchFilter(allFilters, pointer),
      freeSolo: !allowPasteCSV,
      keyPropertyName: field.name,
      multiple: true,
      onChange: (e, values) => {
        onChange({
          ...value,
          values: values?.map(v => typeof v === 'string' ? v : v?.value)
        });
      },
      requestStart: "focus",
      resourceName: resourceName,
      service: getResourceValues,
      sx: {
        width: '60%'
      },
      textFieldProps: {
        size: 'medium',
        variant: 'standard',
        onKeyDown: allowPasteCSV ? handleEnterMultiple : undefined
      },
      value: inputValues?.map(v => ({
        value: v,
        label: v
      })) || []
    }, field?.name ?? 'empty') : (0, _ComparisonSelector.isBetween)(comparison) ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      display: "flex",
      gap: 1,
      flexDirection: "column",
      width: "60%",
      borderLeft: "1px dotted lightgrey",
      paddingLeft: "8px",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, {
        onChange: e => onChange({
          ...value,
          values: [e.target.value, value.values[1]]
        }),
        placeholder: "Value",
        value: values?.[0] || '',
        variant: "standard",
        sx: {
          '& .MuiInput-root': {
            '&:before': {
              borderColor: 'text.primary'
            }
          }
        }
      }, field?.name ? `${field.name}-from` : 'value-from'), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, {
        onChange: e => onChange({
          ...value,
          values: [value.values[0], e.target.value]
        }),
        placeholder: "Value",
        value: values?.[1] || '',
        variant: "standard",
        sx: {
          '& .MuiInput-root': {
            '&:before': {
              borderColor: 'text.primary'
            }
          }
        }
      }, field?.name ? `${field.name}-to` : 'value-to')]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, {
      onChange: e => onChange({
        ...value,
        values: [e.target.value]
      }),
      placeholder: "Value",
      value: values?.[0] || '',
      variant: "standard",
      sx: {
        width: '60%',
        '& .MuiInput-root': {
          '&:before': {
            borderColor: 'text.primary'
          }
        }
      }
    }), (0, _ComparisonSelector.isSelect)(comparison) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemButton.default, {
      onClick: () => setOpenPasteDialog(true),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContentPaste.default, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuIcon.default, {
      open: Boolean(menu),
      onClick: () => setMenu('open'),
      onClose: () => setMenu(null),
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MoreVert.default, {
        className: classes.icon
      }),
      buttonProps: {
        size: 'small'
      },
      children: !menu ? null : menu === 'open' ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_List.default, {
        sx: {
          width: '200px'
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_ListItemButton.default, {
          onClick: () => setMenu('targetField'),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemIcon.default, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Adjust.default, {
              className: classes.icon
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemText.default, {
            primary: "Target field"
          })]
        }), onDelete && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ListItemButton.default, {
          onClick: onDelete,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemIcon.default, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DeleteOutline.default, {
              className: classes.icon
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemText.default, {
            primary: "Remove"
          })]
        }), onNew && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ListItemButton.default, {
          onClick: () => setMenu('field'),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemIcon.default, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Add.default, {
              className: classes.icon
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemText.default, {
            primary: "New filter"
          })]
        }), onGroup && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ListItemButton.default, {
          onClick: onGroup,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemIcon.default, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LibraryAddOutlined.default, {})
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemText.default, {
            primary: "Create group"
          })]
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(FieldList, {
        properties: properties,
        onAdd: handleMenuField
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Dialog.default, {
      open: openPasteDialog,
      sx: {
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '500px'
          }
        }
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogTitle.default, {
        children: "Paste your content here"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
        display: "flex",
        gap: 1,
        alignItems: "center",
        justifyContent: "center",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, {
          id: "filled-hidden-label-small",
          variant: "filled",
          size: "small",
          onChange: handleTextFieldChange,
          sx: {
            width: '50%',
            '& .MuiFilledInput-root': {
              '&:before': {
                borderColor: 'text.primary'
              }
            }
          },
          value: textFieldValue
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FormControl.default, {
          sx: {
            minWidth: '15%'
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InputLabel.default, {
            id: "demo-simple-select-label",
            children: "Separator"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.default, {
            labelId: "demo-simple-select-label",
            id: "demo-simple-select",
            value: separatorOption,
            onChange: handleSeparatorOptionsChange,
            inputProps: {
              classes: {
                icon: classes.icon
              }
            },
            children: options.map(val => /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem.default, {
              value: val,
              children: val
            }, val))
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_DialogActions.default, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          variant: 'contained',
          onClick: () => setOpenPasteDialog(false),
          children: "Close"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          variant: 'contained',
          disabled: textFieldValue === '',
          onClick: handleDialogApply,
          children: "Apply"
        })]
      })]
    })]
  });
}
function FieldSelect({
  properties,
  name,
  onChange
}) {
  function updateField(p) {
    if (!p) return;
    const {
      name,
      id,
      container
    } = p;
    onChange({
      name,
      id,
      resourceId: container.id,
      resourceName: container.name,
      resourceType: container.type
    });
  }
  const propOptions = properties.sort((a, b) => a.displayName.localeCompare(b.displayName));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Autocomplete.default, {
    disableClearable: true,
    filterSelectedOptions: true,
    getOptionLabel: option => option.displayName,
    isOptionEqualToValue: (o, v) => o.name === v.name,
    onChange: (e, v) => updateField(v),
    options: propOptions,
    renderInput: params => /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, {
      ...params,
      placeholder: "New",
      sx: {
        width: '150px',
        '& .MuiInputBase-root': {
          '&.MuiInput-root': {
            '&.MuiInput-underline': {
              '&:before, &:after': {
                borderBottomColor: 'text.primary'
              }
            }
          }
        },
        '& .MuiAutocomplete-endAdornment': {
          '& .MuiSvgIcon-root': {
            color: 'text.primary'
          }
        }
      },
      variant: "standard"
    }),
    value: name ? properties.find(p => p.name === name) : null
  });
}
function GroupToggle({
  value,
  onToggle
}) {
  if (!value) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
    minWidth: "48px"
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
    color: "primary",
    variant: "contained",
    onClick: onToggle,
    size: "small",
    sx: {
      minWidth: '48px',
      borderRadius: '15px'
    },
    children: value.toUpperCase()
  });
}
function FieldList({
  properties,
  onAdd
}) {
  const [searchString, setSearchString] = (0, _react.useState)('');
  const options = properties?.filter(p => p.displayName.toLocaleLowerCase().includes(searchString.toLocaleLowerCase()));
  function handleClick({
    id,
    name,
    container,
    semanticType
  }) {
    onAdd({
      id,
      name,
      resourceType: container.type,
      resourceId: container.id,
      resourceName: container.name,
      dataTypeId: semanticType.id
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
    height: 200,
    display: "flex",
    flexDirection: "column",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, {
      autoFocus: true,
      fullWidth: true,
      onChange: e => setSearchString(e.target.value.toLowerCase()),
      placeholder: "Search",
      value: searchString
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.default, {
      sx: {
        flex: 1,
        overflow: 'auto'
      },
      children: options?.map((p, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemButton.default, {
        dense: true,
        onClick: () => handleClick(p),
        sx: {
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis'
        },
        children: p.displayName
      }, `${p.id}${index}`))
    })]
  });
}
function HelpButton() {
  const classes = useStyles();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuIcon.default, {
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Help.default, {
      className: classes.icon
    }),
    popoverProps: {
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      },
      transformOrigin: {
        vertical: 'bottom',
        horizontal: 'right'
      }
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      width: "600px",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
        variant: "h6",
        children: "Advanced filters"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
        gutterBottom: true,
        children: "Advanced filters allows you to create deeply nested filter combinations. After adding your first couple filters, you will see the grouping toggle on the left (AND). This can be changed to an OR by clicking it."
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
        gutterBottom: true,
        children: "The menu to the right of the filters allow you to: select a target field (data field to use as a target in place of static values), create a new filter, add the filter to a group or remove the filter."
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
        gutterBottom: true,
        children: "The order of operations is from the top down regardless of the group type (i.e. ANDs do not take precedence over ORs, but rather the top operation is complete before the following)."
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
        children: "After creating filters, there is an option to simplify the expression which moves groups to the top of the expression and collapses unneeded groups for easier readability."
      })]
    })
  });
}
function createSearchFilter(filters, pointer) {
  if (!filters) return;
  let filterArray = [];
  let currentFilters = {
    ...filters
  };
  for (let index of pointer) {
    if (currentFilters.group === 'AND') {
      const filterItems = currentFilters.items.filter((f, i) => f.type === 'filter' && i !== index);
      filterArray = filterArray.concat(filterItems);
    }
    currentFilters = currentFilters.items[index];
  }
  return {
    type: 'group',
    group: 'AND',
    items: filterArray
  };
}

/** Add keys to every filter level for ui referencing */
function addKeys(filters) {
  if (!filters) return;
  function addKey(filter) {
    const key = makeKey();
    if (filter.type === 'group') return {
      ...filter,
      key,
      items: filter.items.map(addKey)
    };
    return {
      ...filter,
      key
    };
  }
  return {
    ...filters,
    key: makeKey(),
    items: filters.items.map(addKey)
  };
}

/** Remove keys from filters */
function removeKeys(filters) {
  if (!filters) return;
  function removeKey({
    key,
    ...filter
  }) {
    if (filter.type === 'filter') return filter;
    return {
      ...filter,
      items: filter.items.map(removeKey)
    };
  }
  const {
    key,
    ...filtersWithoutKey
  } = filters;
  return {
    ...filtersWithoutKey,
    items: filters.items.map(removeKey)
  };
}
function toggleGroupAtPointer(allFilters, pointer) {
  let groupPointer = [...pointer];
  const lastPointer = groupPointer.pop();
  const groupPath = groupPointer.length ? `items[${groupPointer.join('].items.[')}]` : '';
  const filters = groupPath ? (0, _lodash.get)(allFilters, groupPath) : allFilters;
  const isTwoItems = filters.items.length === 2;
  const firstOrLast = lastPointer === 1 || lastPointer === filters.items.length - 1;
  let updated = {
    ...allFilters
  };
  function updateIt(update) {
    if (groupPath) (0, _lodash.set)(updated, groupPath, {
      ...filters,
      ...update
    });else updated = {
      ...filters,
      ...update
    };
  }
  if (isTwoItems) {
    updateIt({
      group: toggle(filters.group)
    });
  } else if (firstOrLast) {
    let firstItems = [...filters.items];
    let lastItems = firstItems.splice(lastPointer === 1 ? 2 : filters.items.length - 1);
    const outerGroup = lastPointer === 1 ? filters.group : toggle(filters.group);
    const innerGroup = toggle(outerGroup);
    updateIt({
      group: outerGroup,
      items: [{
        type: 'group',
        key: makeKey(),
        group: innerGroup,
        items: firstItems
      }, ...lastItems]
    });
  } else {
    let firstItems = [...filters.items];
    const middleItem = firstItems.splice(lastPointer, 1)[0];
    const lastItems = firstItems.splice(lastPointer);
    updateIt({
      group: filters.group,
      items: [{
        type: 'group',
        key: makeKey(),
        group: toggle(filters.group),
        items: [{
          type: 'group',
          key: makeKey(),
          group: filters.group,
          items: firstItems
        }, middleItem]
      }, ...lastItems]
    });
  }
  return (0, _filterUtils.simplifyFilters)(updated);
}
const makeKey = () => (0, _lodash.random)(1000000);
const toggle = group => group === 'AND' ? 'OR' : 'AND';